import { USER_LOGGED_IN, USER_LOGGED_OUT } from "../actions/types";
import meta from "./meta";
import reducerRegistry from "./reducerRegistry";

export default function auth(state = {}, action = {}) {
    switch (action.type) {
        case USER_LOGGED_IN:
            return { ...state, ...action.auth };
        case USER_LOGGED_OUT:
            return {};
        default:
            return state;
    }
}

reducerRegistry.register("auth", auth);


// WEBPACK FOOTER //
// ./src/reducers/auth.js